import polls from './polls.json';

export default {
  polls,
};
